import {
  createDraftSafeSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { GetCampaignListParams } from '@src/api/campaigns/index.d';
import { RootState } from '@src/redux/store';
import { Campaign } from '@src/types/campaign';
import { MetaDto } from '@src/types/meta';
import { getCampaignListThunk } from './campaignListThunk';
import { GetCampaignListReturn, ModalType } from '../types';

interface CampaignListInitialState {
  isLoading: boolean;
  meta: MetaDto;
  params: GetCampaignListParams;
  campaigns: Campaign[];
  modal: ModalType;
}

const campaignListInitialState: CampaignListInitialState = {
  isLoading: false,
  meta: {
    currentPage: 0,
    itemsPerPage: 0,
    totalItems: 0,
    totalPages: 0,
  },
  params: {
    page: 0,
    limit: 0,
    sortBy: [],
    searchBy: [],
    search: '',
    filter: {},
  },
  campaigns: [],
  modal: 'off',
};

const campaignListSlice = createSlice({
  name: 'campaignList',
  initialState: campaignListInitialState,
  reducers: {
    onChangePageNum: (state, { payload }) => {
      state.params.page = payload;
    },
    onChangeSearchOption: (
      state,
      { payload }: PayloadAction<{ label: string; value: string }>
    ) => {
      if (payload === null) {
        state.params.searchBy = [];
      } else {
        state.params.searchBy = [payload.value];
      }
    },
    onChangeSearchValue: (state, { payload }: PayloadAction<string>) => {
      state.params.search = payload;
    },
    onChangeFilters: (state, { payload }) => {
      state.params.filter[payload.target] = payload.value;
    },
    onChangeModal: (state, { payload }) => {
      state.modal = payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getCampaignListThunk.pending, (state) => {
      state.isLoading = true;
    })
      .addCase(
        getCampaignListThunk.fulfilled,
        (state, { payload }: PayloadAction<GetCampaignListReturn>) => {
          const { meta, data } = payload;
          state.isLoading = false;

          state.meta = meta;
          state.campaigns = data;
        }
      )
      .addCase(getCampaignListThunk.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  onChangePageNum,
  onChangeSearchOption,
  onChangeSearchValue,
  onChangeFilters,
  onChangeModal,
} = campaignListSlice.actions;

export default campaignListSlice.reducer;

const selfSelector = (state: RootState) => state.campaignList;
export const campaignListSelector = createDraftSafeSelector(
  selfSelector,
  (state) => state
);
